import { Injectable, inject } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OrganizationResponseDto } from '../schemas/organization-response.dto';
import { CreateOrganizationRequestDto } from '../schemas/create-organization-request.dto';
import { UpdateOrganizationRequestDto } from '../schemas/update-organization-request.dto';
import { TRADGINE_DATA_API_BASE_URL } from '../api-base-url.token';

@Injectable({ providedIn: 'root' })
export class OrganizationAdminApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(TRADGINE_DATA_API_BASE_URL)}/OrganizationAdmin`;

    getAll() {
        return this.builder
            .url(`${this.controllerUrl}/getAll`)
            .get()
            .json<OrganizationResponseDto[]>()
            .build()
            .send();
    }

    getById(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/getById`)
            .get()
            .json<OrganizationResponseDto>()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }

    create(payload: CreateOrganizationRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/create`)
            .post(payload)
            .json<OrganizationResponseDto>()
            .build()
            .send();
    }

    update(payload: UpdateOrganizationRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/update`)
            .put(payload)
            .json<OrganizationResponseDto>()
            .build()
            .send();
    }

    delete(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/delete`)
            .delete()
            .text()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }
}
